import { 
  NetworkType, 
  NetworkProvider, 
  NetworkInfrastructure, 
  NetworkDefinition, 
  ExtendedNetworkDefinition,
  DashboardNetworkType,
  convertNetworkTypeToDashboard
} from "@/components/dashboard/network/NetworkTypes";

export const mockNetworks: ExtendedNetworkDefinition[] = [
  {
    id: 'net-101',
    name: 'Google Cloud Mesh East',
    provider: 'google',
    type: 'cloud',
    region: 'us-east1',
    infrastructure: 'vm',
    nodes: 12,
    isActive: true,
    createdAt: '2023-08-15',
    status: 'active',
    metrics: {
      packetLoss: 0.5,
      signalStrength: 92,
      latency: 15
    }
  },
  {
    id: 'net-102',
    name: 'AWS Container Network',
    provider: 'aws',
    type: 'cloud',
    region: 'us-west-2',
    infrastructure: 'container',
    nodes: 24,
    isActive: true,
    createdAt: '2023-09-22',
    status: 'active',
    metrics: {
      packetLoss: 0.3,
      signalStrength: 95,
      latency: 12
    }
  },
  {
    id: 'net-103',
    name: 'Azure Enterprise Mesh',
    provider: 'azure',
    type: 'hybrid',
    region: 'eastus2',
    infrastructure: 'vm',
    nodes: 18,
    isActive: true,
    createdAt: '2023-10-05',
    status: 'active',
    metrics: {
      packetLoss: 0.7,
      signalStrength: 88,
      latency: 18
    }
  },
  {
    id: 'net-104',
    name: 'ATT Fiber Backbone',
    provider: 'att',
    type: 'fiber',
    region: 'southeast',
    infrastructure: 'dedicated',
    nodes: 8,
    isActive: false,
    createdAt: '2023-11-12',
    status: 'inactive',
    metrics: {
      packetLoss: 2.1,
      signalStrength: 45,
      latency: 35
    }
  },
  {
    id: 'net-105',
    name: 'Verizon 5G Edge Network',
    provider: 'verizon',
    type: '5g',
    region: 'northeast',
    infrastructure: 'dedicated',
    nodes: 15,
    isActive: true,
    createdAt: '2023-12-01',
    status: 'active',
    metrics: {
      packetLoss: 0.8,
      signalStrength: 90,
      latency: 14
    }
  }
];

// Helper functions
export const getNetworkById = (id: string): ExtendedNetworkDefinition | undefined => {
  return mockNetworks.find(network => network.id === id);
};

export const getNetworksByProvider = (provider: NetworkProvider): ExtendedNetworkDefinition[] => {
  return mockNetworks.filter(network => network.provider === provider);
};

export const getNetworksByType = (type: NetworkType): ExtendedNetworkDefinition[] => {
  return mockNetworks.filter(network => network.type === type);
};

export const getNetworksByInfrastructure = (infrastructure: NetworkInfrastructure): ExtendedNetworkDefinition[] => {
  return mockNetworks.filter(network => network.infrastructure === infrastructure);
};

// Helper function to adapt ExtendedNetworkDefinition to Dashboard's Network type
export const adaptToDashboardNetwork = (network: ExtendedNetworkDefinition) => {
  return {
    id: network.id,
    name: network.name,
    type: convertNetworkTypeToDashboard(network.type),
    status: network.status,
    metrics: network.metrics
  };
};
